import type { SidebarNavItem } from '@/components/SidebarNavRail/types';

/**
 * Orders a section's pages A–Z for its rail, so a long person nav reads like an index. Pinned
 * entries — the record open beside the section — stay on top.
 */
const sortNavItems = <T extends SidebarNavItem>(items: T[]): T[] => [
  ...items.filter((item) => item.pinned),
  ...items.filter((item) => !item.pinned).sort((a, b) => a.label.localeCompare(b.label))
];

export default sortNavItems;
